module.exports = __webpack_public_path__ + "92882dd3c89ed2548dca2829741cf0cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/evaluation_report/assets/writingBg.jpg
// module id = 793
// module chunks = 0